const PARTNER_NAME_WITH_LINK_NAMESPACE = 'jbp-reports'

export const TRANSLATION_KEYS = {
  openPartnerPlan: `${PARTNER_NAME_WITH_LINK_NAMESPACE}--table-open-partner-plan`,
}
